import { type ReactElement } from 'react'
import * as S from './testimonials.styled'
import { TestimonialLinks } from '../testimonial-links/testimonial-links'
import { LinkButton } from '../button/link-button'

export function Testimonials (): ReactElement {
  return <S.Container>
    <S.Content>
      <S.TextContent>
        <h6>Depoimentos</h6>
        <div>
          <h1>Veja o que nossos clientes falam sobre o Cartão de TODOS</h1>
          <p>Faça como mais de  18 milhões de filiados e venha aproveitar todos os benefícios que só o Cartão de TODOS tem!</p>
          <LinkButton to="https://idpv.cartaodetodos.com.br/dados-pessoais/?from_lead=1&idpv=593fe813-3579-442f-b0c2-17a883e92e24">Peça já o seu</LinkButton>
        </div>
      </S.TextContent>
      <TestimonialLinks />
    </S.Content>
  </S.Container>
}
